import { localDateParse } from '@/uteis/converters/LocalDateConverter'
import { protocoloParse, tipoContatoExterno } from '@/uteis/converters/ProtocoloConverter'
import { interessadoParse } from '@/uteis/converters/InteressadoConverter'
import { identificadorParse } from '@/uteis/converters/IdentificadorConverter'

export const converter = (converterName, value) => {
  return converters[converterName](value)
}

const converters = {
  localDate: localDateParse,
  protocolo: protocoloParse,
  interessados: interessadoParse,
  identificador: identificadorParse,
  tipoContatoExterno
}
